import React from 'react'
import { useSelector } from 'react-redux';
import { LANDSCAPE } from '../../config/Constant';
import CustomModal_Potrait from './customModal_Potrait';
import CustomModal_Landscape from './customModal_Landscape';

export const CustomModal = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));
    
    if(appOrientation === LANDSCAPE){
        return <CustomModal_Landscape {...props} />
    }

    return <CustomModal_Potrait {...props} />
}
